import React, { useState, useReducer } from "react";
import { Row, Col, Input, Button } from "antd";
import {
  EyeTwoTone,
  EyeInvisibleOutlined,
  Loading3QuartersOutlined,
} from "@ant-design/icons";
import Axios from "axios";
import { Validation } from "../Validation/VAlidation";
import "./SignUp.css";
import constants from "../constants/constants.json";
import Message from "../helper/Message";
import { useHistory } from "react-router-dom";
import { setUserInfo } from "../store/actions/user";
import { useDispatch } from "react-redux";

const SET_NAME = "SET_NAME";
const SET_EMAIL = "SET_EMAIL";
const SET_PASSWORD = "SET_PASSWORD";
const SET_VALIDEMAIL = "SET_VALIDEMAIL";
const RESET = "RESET";

const userRegister = (state, action) => {
  switch (action.type) {
    case SET_NAME:
      return {
        ...state,
        name: action.name,
        nameRequire: action.nameRequire,
      };

    case SET_EMAIL:
      return {
        ...state,
        mail: action.mail,
        mailRequire: action.mailRequire,
      };
    case SET_PASSWORD:
      return {
        ...state,
        password: action.password,
        passwordRequire: action.passwordRequire,
      };
    case SET_VALIDEMAIL:
      return {
        ...state,
        mailerror: action.valid,
        mailRequire: action.mailRequire,
      };
    case RESET:
      return {
        ...state,
        name: "",
        mail: "",
        password: "",
        mailerror: true,
        nameRequire: false,
        mailRequire: false,
        passwordRequire: false,
      };
    default:
      return state;
  }
};
export default function SignUp(props) {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const [user, dispatchUser] = useReducer(userRegister, {
    name: "",
    mail: "",
    password: "",
    mailerror: true,
    nameRequire: false,
    mailRequire: false,
    passwordRequire: false,
  });

  const register = async () => {
    if (
      user.name === "" ||
      user.mail === "" ||
      user.password === "" ||
      !user.mailerror
    ) {
      Message.warning("fill all blanks");
      return;
    }
    try {
      setLoading(true);
      const response = await Axios.post(constants.url + "/user/register", {
        user: {
          name: user.name,
          mail: user.mail,
          password: user.password,
        },
      });
      if (response.data.status === 201) {
        dispatchUser({ type: RESET });
        localStorage.setItem("pnsToken", response.data.result.session.token);
        dispatch(
          setUserInfo({
            personal: {
              name: user.name,
              id: response.data.result.user.id,
              email: user.mail,
            },
          })
        );
        history.replace("/dashboard");
        setLoading(false);
      } else {
        Message.warning(response.data.result.message);
        setLoading(false);
      }
    } catch (error) {
      Message.error("Communication error");
      setLoading(false);
    }
  };
  return (
    <Row gutter={[10, 20]} className="content-tab-login" justify="center">
      <Col span={24}>
        <Row justify="center">
          <Col
            // className="column-flex-style"
            xs={24}
            sm={20}
            lg={16}
            xl={16}
          >
            {/* <span className="label">email</span> <Input /> */}

            <span className="label">Name</span>
            <Input
              onChange={(e) => {
                dispatchUser({ type: SET_NAME, name: e.target.value });
              }}
              user={user.name}
              className="login-input"
              type="text"
              id="Name"
              onBlur={(e) => {
                dispatchUser({
                  type: SET_NAME,
                  name: e.target.value,
                  nameRequire: e.target.value.length < 1 ? true : false,
                });
              }}
            />
            {user.nameRequire ? (
              <span className="signup-require">name is require</span>
            ) : null}
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row justify="center">
          <Col
            // className="column-flex-style"
            style={{ position: "relative" }}
            xs={24}
            sm={20}
            lg={16}
            xl={16}
          >
            <label htmlFor="email" className="label">
              {" "}
              email
            </label>
            <Input
              className="login-input"
              type="email"
              value={user.mail}
              name="email"
              id="email"
              onChange={(e) => {
                dispatchUser({ type: SET_EMAIL, mail: e.target.value });
              }}
              onBlur={(e) => {
                let valid = Validation.emailValidation(e.target.value);
                dispatchUser({
                  type: SET_VALIDEMAIL,
                  valid: valid,
                  mailRequire: e.target.value.length < 1 ? true : false,
                });
              }}
            />
            {!user.mailerror ? (
              <span className="register-valid-email">email is incorrect</span>
            ) : null}
            {user.mailRequire ? (
              <span className="signup-require">email is require</span>
            ) : null}
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row justify="center">
          <Col
            // className="column-flex-style"
            xs={24}
            sm={20}
            lg={16}
            xl={16}
          >
            {/* <span className="label">email</span> <Input /> */}

            <span className="label">Password</span>
            <Input.Password
              value={user.password}
              className="login-input"
              type="password"
              id="password"
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
              onChange={(e) => {
                dispatchUser({ type: SET_PASSWORD, password: e.target.value });
              }}
              onBlur={(e) => {
                dispatchUser({
                  type: SET_PASSWORD,
                  password: e.target.value,
                  passwordRequire: e.target.value.length < 1 ? true : false,
                });
              }}
            />
            {user.passwordRequire ? (
              <span className="signup-require">password is require</span>
            ) : null}
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <div className="login-button-container">
          <Button
            type="primary"
            onClick={register}
            loading={loading ? <Loading3QuartersOutlined spin /> : false}
            style={{
              marginTop: "20px",
            }}
          >
            SignUp
          </Button>
        </div>
      </Col>
    </Row>
  );
}
